<template>
    <div class="qurePage">
        <img src="../../assets/bg@2x.png" class="headerImg" alt="" srcset="">

        <div class="content">
            <div class="header_tot"></div>
            <div class="showb"></div>
            <div class="body">

                <p class="tips">注：简述题输入内容限制在200字以内</p>
                <div>
                    <p class="title">1. 当前店面热销车型<span class="red">*</span></p>
                    <van-field v-model="qsStore.popularModel" class="inputs" rows="1" type="textarea" autosize
                        placeholder="请输入内容（必填）" :rules="[{ validator, message: '请输入内容' }]" />
                </div>
                <div>
                    <p class="title">2. 当前店面热销配置<span class="red">*</span></p>
                    <van-field v-model="qsStore.popularConfig" class="inputs" rows="1" type="textarea" autosize
                        placeholder="请输入内容（必填）" />
                </div>
                <div>
                    <p class="title">3. 当前店面热销颜色<span class="red">*</span></p>
                    <van-field v-model="qsStore.popularColor" class="inputs" rows="1" type="textarea" autosize
                        placeholder="请输入内容（必填）" />
                </div>
                <div>
                    <p class="title">4. 当前店面缺失品类及款型 <span class="red">*</span></p>
                    <van-field v-model="qsStore.missingCategoryAndType" class="inputs" rows="1" type="textarea" autosize
                        placeholder="请输入内容（必填）" />
                </div>
                <div>
                    <p class="title">5. 当前店面遇到的产品质量问题及照片<span class="red">*</span></p>
                    <van-field v-model="qsStore.qcProblem" class="inputs" rows="1" type="textarea" autosize
                        placeholder="请输入内容（必填）" />
                </div>
                <div>
                    <p class="title">上传照片（选填）<span class="red">(最多上传3张)</span></p>
                    <div class="uploadImg">
                        <div class="imgbox" v-for="(item, index) in imgList" :key="index">
                            <img :src="item" class="carme" alt="" srcset="" @click="ImagePreviewcc(item)" />
                            <van-icon name="clear" class="closeImg" @click="deleteImg(index)" />
                        </div>
                        <div class="imgbox">
                            <van-uploader :after-read="afterRead" capture='camera'>
                            </van-uploader>
                            <!-- <img src="../../assets/upload@2x.png" class="carme" @click="goCamera" /> -->
                        </div>
                    </div>
                </div>
                <div>
                    <p class="title"> 6. 当前店面遇到的其他问题（服务类等）<span class="red">*</span></p>
                    <van-field v-model="qsStore.otherProblem" class="inputs" rows="1" type="textarea" autosize
                        placeholder="请输入内容（必填）" />
                </div>
                <div>
                    <p class="title">7. 经销商对公司的建议<span class="red">*</span></p>
                    <van-field v-model="qsStore.dealerCompanySuggestion" class="inputs" rows="1" type="textarea"
                        autosize placeholder="请输入内容（必填）" />
                </div>
            </div>
        </div>
        <div class="box_btn">
            <van-button type="primary" class="goback" @click="goback">上一步</van-button>
            <van-button type="primary" class="onNext" @click="onNext">{{ butText }}</van-button>
        </div>
    </div>
</template>

<script>
import { addInspect, checkHasQsCity, postUplodBase64 } from '../../apis/storeVisit'
import { Toast, ImagePreview } from 'vant';
import wxChooseImage from '@/utils/wxChooseImage'
export default {
    data() {
        return {
            "qsStore": {
                "popularModel": "",
                "popularConfig": "",
                "popularColor": "",
                "missingCategoryAndType": "",
                "qcProblem": "",
                "qcProblemPic": "",
                "otherProblem": "",
                "dealerCompanySuggestion": ""
            },
            imgList: [],
            butText: '下一步',
            isNext: false,
        }
    },
    mounted() {
        let params = {
            openId: this.$store.state.storeVisit.inspect.openId,
            address: this.$store.state.storeVisit.inspect.location,
        }
        checkHasQsCity(params).then(res => {
            this.isNext = res.data;
            if (res.data == true) {
                this.butText = '下一步';
            } else {
                this.butText = '提交'
            }
        });
    },
    methods: {
        validator(val) {
            console.log(val)
            return val == '' ? false : true;
        },
        ImagePreviewcc(val) {
            ImagePreview([val]);
        },
        afterRead(file) {
            if (this.imgList.length >= 3) {
                Toast({
                    message: '图片最多上传3张'
                })
                return
            }
            let data = {
                base: file.content
            }

            postUplodBase64(data).then(res => {
                if (res.data) {
                    this.imgList.push(res.data.objectUrl)
                }

            })
        },

        async goCamera() {
            if (this.imgList.length >= 3) {
                Toast({
                    message: '图片最多上传3张'
                })
                return
            }
            let base64 = await wxChooseImage.getLocalImgData()
            let data = {
                base: 'data:image/jpeg;base64,' + base64
            }
            postUplodBase64(data).then(res => {
                if (res.data) {
                    this.imgList.push(res.data.objectUrl)
                }

            })
        },
        deleteImg(i) {
            this.imgList.splice(i, 1)
        },
        goback() {
            this.$router.go(-1)
        },
        onNext() {
            for (const key in this.qsStore) {
                if (this.qsStore.hasOwnProperty.call(this.qsStore, key)) {
                    const element = this.qsStore[key];
                    console.log(key, element)
                    if (key != 'qcProblemPic') {
                        if (!element) {
                            Toast({
                                message: '请填写表单内容'
                            })
                            return
                        }
                    }
                }
            }
            this.qsStore.qcProblemPic = this.imgList.join(',')
            this.$store.state.storeVisit.qsStore = this.qsStore;

            if (!this.isNext) {
                console.log(this.$store.state.storeVisit)
                this.$store.state.storeVisit.qsCity = null
                let data = this.$store.state.storeVisit;
                addInspect(data).then(res => {
                    if (res.status === 0) {
                        this.keepRemoveCache();
                        this.$router.replace('/storevisit')
                    } else {
                        Toast({
                            message: res.msg
                        })
                    }
                })
            } else {

                this.$router.push({
                    path: '/market'
                })
            }


        },
        //请输keep缓存
        keepRemoveCache() {
            let vnode = this.$vnode
            let parentVnode = vnode && vnode.parent;
            if (parentVnode && parentVnode.componentInstance && parentVnode.componentInstance.cache) {
                var key = vnode.key == null
                    ? vnode.componentOptions.Ctor.cid + (vnode.componentOptions.tag ? `::${vnode.componentOptions.tag}` : '')
                    : vnode.key;
                var cache = parentVnode.componentInstance.cache;
                var keys = parentVnode.componentInstance.keys;
                console.log(cache, keys)
                keys.forEach(element => {
                    cache[element] = null
                });
                if (cache[key]) {
                    // remove key
                    if (keys.length) {
                        var index = keys.indexOf(key)
                        if (index > -1) {
                            keys.splice(index, 1)
                        }
                    }

                    cache[key] = null
                }
            }
        }
    },
}
</script>

<style lang="scss" >
.qurePage {
    background: linear-gradient(-26deg, #FFE2B8 0%, #FFFCF7 100%);
    height: 100%;

    .van-uploader__upload {
        width: 100px !important;
        height: 100px !important;
    }

    .body {
        padding: 0 12px 12px 12px;
    }

    .headerImg {
        width: 100%;
    }

    .header_tot {
        background: #D44F1B;
        height: 20px;
    }

    .showb {
        background: linear-gradient(0deg, #fff 0%, #FF5313 100%);
        height: 15px;
    }

    .box_btn {
        display: flex;
        justify-content: space-around;
        padding: 30px 0;
    }

    .goback {
        background: #FFFFFF;
        border-radius: 24px;
        border: 0;
        color: #000;
        width: 40%;
    }

    .onNext {
        background: linear-gradient(0deg, #FF232D 0%, #FE6428 100%);
        box-shadow: 4px 9px 27px 0px rgba(255, 35, 45, 0.38);
        border-radius: 24px;
        border: 0;
        width: 40%;
    }

    .content {
        text-align: left;
        margin: 0 20px;
        background-color: #fff;
        // padding: 12px;
        margin-top: -50px;
        box-shadow: 6px 10px 7px 0px rgba(255, 225, 180, 0.56);

        .tips {
            font-size: 12px;
            font-weight: 400;
            color: #FF0000;
        }

        .red {
            color: #FF0000;
        }

        .title {
            font-size: 14px;
            font-weight: 600;
            color: #333333;
        }

        .inputs {
            background: #F7F7F7;
            border-radius: 8px;
        }

        .uploadImg {
            display: flex;
            flex-wrap: wrap;

            .imgbox {
                position: relative;
                margin-right: 10px;
                width: 30%;
            }

            .carme {
                width: 100%;
                height: 100px;
            }

            .closeImg {
                position: absolute;
                font-size: 22px;
                color: #777;
                font-weight: bold;
                right: -5px;
                top: 0;
                z-index: 999;
            }
        }
    }

}
</style>